import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { addToBasket, removeFromBasket } from '@/js/lib/api/cart';
import { useCartStore } from '@/js/lib/store/cart';
import { useCommonStore } from '@/js/lib/store/common';
import { info } from '@/js/lib/ui';
import { mountModal } from '@/js/lib/ui/helper/dynamic-modal';
import IModal from '@/js/components/molecules/IModal.vue';
import CartModal from './CartModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlreadyInCartModal',
  props: {
    itemId: {},
    itemOptionVariantSlugs: {}
  },
  setup(__props: any) {

const { isWebView } = useCommonStore();
const cartStore = useCartStore();

const props = __props;

const onOk = async () => {
  try {
    await removeFromBasket({ itemId: props.itemId });
    await addToBasket({ itemId: props.itemId, itemOptionVariantSlugs: props.itemOptionVariantSlugs });

    // 以前のeコマースオブジェクトをクリアする
    // eslint-disable-next-line unicorn/no-null
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_id: props.itemId,
            quantity: 1,
          },
        ],
      },
    });

    if (isWebView) {
      info('カートの内容を変更しました', { fadeOut: true });
      return;
    }
    await cartStore.loadBaskets();
    mountModal({
      Component: CartModal,
      props: {
        text: 'カートの内容を変更しました',
      },
    });
  } catch (error) {
    if (error?.response?.data?.errors.includes('stock_missing')) {
      info('注文個数が在庫数を超えています');
    } else {
      info('カートの内容を変更できませんでした');
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IModal, {
    "text-cancel": "いいえ",
    "text-ok": "変更する",
    "with-action-button": true,
    onOk: onOk
  }, {
    footer: _withCtx(() => [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.footer)
      }, "※ 異なるオプションも購入されたい場合、別途ご注文ください。", 2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("h3", {
        class: _normalizeClass(_ctx.$style.title)
      }, "カート内の購入オプションを変更しますか？", 2),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.message)
      }, "同じ作品内で異なるオプションは同時に購入できません。こちらのオプションに変更しますか？", 2),
      _cache[1] || (_cache[1] = _createTextVNode())
    ]),
    _: 1,
    __: [0,1]
  }))
}
}

})